import React from 'react';
import { Container } from './styles';
import { menuListItems } from '../../assets/menu/menuList';
import { Menu } from '../../components/Menu';
import { EventsTable } from './EventsTable';

export const Events: React.FC = () => {

  return (
    <Menu links={menuListItems}>
      <Container>
        <EventsTable/>
      </Container>
    </Menu>
  )
} 